module.exports = __webpack_public_path__ + "img/conclusion3.69176adb.svg";